import { Network } from "../Network";
import { RegisterEndPoints } from "apis/EndPoints/RegisterEndPoints";

export class RegisterServices {
  static getRegisteredClients(data = {}) {
    return Network.fetch(RegisterEndPoints.getRegisteredClients.url(), {
      headers: {
        "Content-type": "application/json; charset=UTF-8",
        Authorization: data?.password,
        From: data?.username,
      },
      method: RegisterEndPoints.getRegisteredClients.method,
    });
  }

  static registerNewClient(username, password, data) {
    return Network.fetch(RegisterEndPoints.registerNewClient.url(), {
      headers: {
        "Content-type": "application/json; charset=UTF-8",
        Authorization: password,
        From: username,
      },
      body: JSON.stringify(data),
      method: RegisterEndPoints.registerNewClient.method,
    });
  }

  static updateRegisteredClient(username, password, data) {
    return Network.fetch(RegisterEndPoints.updateRegisteredClient.url(), {
      headers: {
        "Content-type": "application/json; charset=UTF-8",
        Authorization: password,
        From: username,
      },
      body: JSON.stringify(data),
      method: RegisterEndPoints.updateRegisteredClient.method,
    });
  }

  static deleteRegisteredClient(username, password, data) {
    return Network.fetch(RegisterEndPoints.deleteRegisteredClient.url(), {
      headers: {
        "Content-type": "application/json; charset=UTF-8",
        Authorization: password,
        From: username,
      },
      body: JSON.stringify(data),
      method: RegisterEndPoints.deleteRegisteredClient.method,
    });
  }

  static getClientSubscriptions(username, password, data) {
    return Network.fetch(RegisterEndPoints.getClientSubscriptions.url(), {
      headers: {
        "Content-type": "application/json; charset=UTF-8",
        Authorization: password,
        From: username,
      },
      // body: JSON.stringify(data),
      method: RegisterEndPoints.getClientSubscriptions.method,
    });
  }

  static registerClientSubscriptions(username, password, data) {
    return Network.fetch(RegisterEndPoints.registerClientSubscriptions.url(), {
      headers: {
        "Content-type": "application/json; charset=UTF-8",
        Authorization: password,
        From: username,
      },
      body: JSON.stringify(data),
      method: RegisterEndPoints.registerClientSubscriptions.method,
    });
  }
  static updateClientSubscriptions(username, password, data) {
    return Network.fetch(RegisterEndPoints.updateClientSubscriptions.url(), {
      headers: {
        "Content-type": "application/json; charset=UTF-8",
        Authorization: password,
        From: username,
      },
      body: JSON.stringify(data),
      method: RegisterEndPoints.updateClientSubscriptions.method,
    });
  }

  static clearProcurementLogForProject(data) {
    return Network.fetch(
      RegisterEndPoints.clearProcurementLogForProject.url(
        data?.companyID,
        data?.projectID
      ),
      {
        headers: {
          "Content-type": "application/json; charset=UTF-8",
          Authorization: data?.password,
          From: data?.username,
        },
        body: JSON.stringify(data),
        method: RegisterEndPoints.clearProcurementLogForProject.method,
      }
    );
  }
}
